import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';
const TextoPadrao = () => {
  const [textosPadrao, setTextosPadrao] = useState([]);
  const [filteredTextosPadrao, setFilteredTextosPadrao] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [editing, setEditing] = useState(null);
  const [departamentos, setDepartamentos] = useState([]);
  const [view, setView] = useState('list');
  const [activeTab, setActiveTab] = useState('texto_padrao');
  const [formData, setFormData] = useState({
    titulo: '',
    id_depto: '',
    texto_padrao: '',
    termo_abertura: '',
    p01: '',
    p02: '',
    p03: '',
    p04: '',
    p05: '',
    p06: '',
    p07: '',
    p08: '',
    p09: '',
    p10: '',
    obs: '',
    ativo: true
  });

  const tabs = [
    { id: 'texto_padrao', label: 'Texto Padrão', field: 'texto_padrao' },
    { id: 'termo_abertura', label: 'Termo Abertura', field: 'termo_abertura' },
    { id: 'p01', label: 'Parágrafo 01', field: 'p01' },
    { id: 'p02', label: '02', field: 'p02' },
    { id: 'p03', label: '03', field: 'p03' },
    { id: 'p04', label: '04', field: 'p04' },
    { id: 'p05', label: '05', field: 'p05' },
    { id: 'p06', label: '06', field: 'p06' },
    { id: 'p07', label: '07', field: 'p07' },
    { id: 'p08', label: '08', field: 'p08' },
    { id: 'p09', label: '09', field: 'p09' },
    { id: 'p10', label: '10', field: 'p10' },
    { id: 'obs', label: 'Obs', field: 'obs' }
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [txRes, depRes] = await Promise.all([
          fetch(`${API_BASE_URL}/texto-padrao`),
          fetch(`${API_BASE_URL}/departamentos`)
        ]);
        if (!txRes.ok) throw new Error('Erro ao buscar textos padrão');
        if (!depRes.ok) throw new Error('Erro ao buscar departamentos');
        const [tx, deps] = await Promise.all([txRes.json(), depRes.json()]);
        setTextosPadrao(tx);
        setFilteredTextosPadrao(tx);
        setDepartamentos(deps);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  const handleSearch = (term) => {
    setSearchTerm(term);
    const lower = term.toLowerCase();
    setFilteredTextosPadrao(
      textosPadrao.filter((t) =>
        (t.titulo || '').toLowerCase().includes(lower) ||
        (t.departamento || '').toLowerCase().includes(lower)
      )
    );
  };

  const startNew = () => {
    setEditing(null);
    setView('form');
    setActiveTab('texto_padrao');
    setFormData({
      titulo: '',
      id_depto: '',
      texto_padrao: '',
      termo_abertura: '',
      p01: '',
      p02: '',
      p03: '',
      p04: '',
      p05: '',
      p06: '',
      p07: '',
      p08: '',
      p09: '',
      p10: '',
      obs: '',
      ativo: true
    });
  };

  const startEdit = (item) => {
    setEditing(item);
    setView('form');
    setActiveTab('texto_padrao');
    setFormData({
      titulo: item.titulo || '',
      id_depto: item.id_depto ? String(item.id_depto) : '',
      texto_padrao: item.texto_padrao || '',
      termo_abertura: item.termo_abertura || '',
      p01: item.p01 || '',
      p02: item.p02 || '',
      p03: item.p03 || '',
      p04: item.p04 || '',
      p05: item.p05 || '',
      p06: item.p06 || '',
      p07: item.p07 || '',
      p08: item.p08 || '',
      p09: item.p09 || '',
      p10: item.p10 || '',
      obs: item.obs || '',
      ativo: item.ativo
    });
  };

  const resetForm = () => {
    setEditing(null);
    setView('list');
    setActiveTab('texto_padrao');
    setFormData({
      titulo: '',
      id_depto: '',
      texto_padrao: '',
      termo_abertura: '',
      p01: '',
      p02: '',
      p03: '',
      p04: '',
      p05: '',
      p06: '',
      p07: '',
      p08: '',
      p09: '',
      p10: '',
      obs: '',
      ativo: true
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.titulo.trim() || !formData.id_depto) {
      alert('Preencha Título e Departamento.');
      return;
    }
    const payload = { ...formData, id_depto: parseInt(formData.id_depto, 10) };
    try {
      if (editing) {
        const res = await fetch(`${API_BASE_URL}/texto-padrao/${editing.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!res.ok) throw new Error('Erro ao atualizar texto padrão');
        const updated = await res.json();
        const dept = departamentos.find((d) => d.id_departamento === updated.id_depto);
        const updatedWithDept = { ...updated, departamento: dept ? dept.nome_departamento : '' };

        setTextosPadrao((prev) => prev.map((t) => (t.id === editing.id ? updatedWithDept : t)));
        setFilteredTextosPadrao((prev) => prev.map((t) => (t.id === editing.id ? updatedWithDept : t)));
      } else {
        const res = await fetch(`${API_BASE_URL}/texto-padrao`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!res.ok) throw new Error('Erro ao criar texto padrão');
        const created = await res.json();
        const dept = departamentos.find((d) => d.id_departamento === created.id_depto);
        const createdWithDept = { ...created, departamento: dept ? dept.nome_departamento : '' };

        setTextosPadrao((prev) => [...prev, createdWithDept]);
        setFilteredTextosPadrao((prev) => [...prev, createdWithDept]);
      }
      resetForm();
    } catch (err) {
      console.error(err);
      alert('Erro ao salvar texto padrão: ' + err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Excluir este texto padrão?')) return;
    try {
      const res = await fetch(`${API_BASE_URL}/texto-padrao/${id}`, { method: 'DELETE' });
      if (!res.ok && res.status !== 204) throw new Error('Erro ao excluir texto padrão');
      setTextosPadrao((prev) => prev.filter((t) => t.id !== id));
      setFilteredTextosPadrao((prev) => prev.filter((t) => t.id !== id));
      if (editing && editing.id === id) resetForm();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Texto Padrão</h1>
        </div>
        {view === 'list' ? (
          <button className="btn-primary" onClick={startNew}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14" />
            </svg>
            Novo Texto
          </button>
        ) : (
          <button
            className="btn-secondary"
            type="button"
            onClick={resetForm}
          >
            Voltar para lista
          </button>
        )}
      </div>

      {view === 'list' && (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8" />
                <path d="M21 21l-4.35-4.35" />
              </svg>
              <input
                type="text"
                placeholder="Buscar por título ou departamento..."
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredTextosPadrao.length} registro(s) encontrado(s)</span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Título</th>
                  <th>Departamento</th>
                  <th>Status</th>
                  <th className="acoes-col">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredTextosPadrao.map((texto) => (
                  <tr key={texto.id}>
                    <td>{texto.id}</td>
                    <td className="contexto-cell">{texto.titulo}</td>
                    <td>{texto.departamento}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={texto.ativo}
                          onChange={() =>
                            startEdit({ ...texto, ativo: !texto.ativo })
                          }
                          id={`toggle-texto-${texto.id}`}
                        />
                      </div>
                    </td>
                    <td className="acoes-col">
                      <div className="action-buttons">
                        <button
                          className="btn-edit"
                          onClick={() => startEdit(texto)}
                          title="Editar"
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                          </svg>
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => handleDelete(texto.id)}
                          title="Excluir"
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <polyline points="3,6 5,6 21,6" />
                            <path d="M19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2V6" />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filteredTextosPadrao.length === 0 && (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8" />
                  <path d="M21 21l-4.35-4.35" />
                </svg>
                <h3>Nenhum texto padrão encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo texto padrão.</p>
              </div>
            )}
          </div>
        </div>
      )}

      {view === 'form' && (
        <div className="form-container" style={{ marginTop: 20, width: '100%', maxWidth: 'none', padding: '0 20px' }}>
          <div className="form-header" style={{ fontSize: '0.85rem' }}>
            <div className="form-row" style={{ width: '100%', marginBottom: '-5px' }}>
              <div className="form-group" style={{ flex: 1, marginTop: '-8px', marginBottom: '-5px' }}>
                <label htmlFor="titulo" style={{ fontSize: '0.8rem' }}>Título *</label>
                <input
                  type="text"
                  id="titulo"
                  value={formData.titulo}
                  onChange={(e) => setFormData({ ...formData, titulo: e.target.value })}
                  required
                  style={{ fontSize: '0.85rem', padding: '8px' }}
                />
              </div>
              <div className="form-group" style={{ width: 320, marginTop: '-8px', marginBottom: '-5px' }}>
                <label htmlFor="id_depto" style={{ fontSize: '0.8rem' }}>Departamento *</label>
                <select
                  id="id_depto"
                  value={formData.id_depto}
                  onChange={(e) => setFormData({ ...formData, id_depto: e.target.value })}
                  required
                  style={{ fontSize: '0.85rem', padding: '8px' }}
                >
                  <option value="">Selecione</option>
                  {departamentos.map((d) => (
                    <option key={d.id_departamento} value={d.id_departamento}>
                      {d.nome_departamento}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="form-content">
            <div className="tab-container" style={{ marginTop: '-10px' }}>
              <div className="tab-buttons" style={{ marginBottom: 10, display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    type="button"
                    className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                    style={{ padding: '6px 12px', fontSize: '0.75rem', whiteSpace: 'nowrap' }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
              <div className="tab-content">
                {(() => {
                  const active = tabs.find((t) => t.id === activeTab);
                  const field = active ? active.field : 'texto_padrao';
                  const rows = field === 'obs' ? 6 : 15;
                  return (
                    <textarea
                      rows={rows}
                      value={formData[field]}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          [field]: e.target.value
                        })
                      }
                      style={{ fontSize: '0.85rem', minHeight: '400px' }}
                    />
                  );
                })()}
              </div>
            </div>

            <div className="form-actions" style={{ marginTop: 12 }}>
              <button type="button" className="btn-secondary" onClick={resetForm}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                {editing ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default TextoPadrao;
